import { Link, LinkProps } from "@/lib/router-compat";
import { usePrefetch } from "@/hooks/usePrefetch";
import { PrefetchKey } from "@/lib/routePrefetchers";

interface PrefetchLinkProps extends LinkProps {
  prefetch?: PrefetchKey;
}

const PrefetchLink = ({ prefetch, ...props }: PrefetchLinkProps) => {
  const handlers = usePrefetch(prefetch);
  return <Link {...handlers} {...props} />;
};

export default PrefetchLink;
